import React from 'react'

const LabelWrapper = ({children, label}) => {
  return (
     <span className="ant-input-group-wrapper">
          <span className="ant-input-wrapper ant-input-group">
            <span className="ant-input-group-addon">{label}</span>
            {children}
          </span>
        </span>
  )
}

export default LabelWrapper